import { render, staticRenderFns } from "./userInfoRe.vue?vue&type=template&id=39d632b8&scoped=true&"
import script from "./userInfoRe.vue?vue&type=script&lang=js&"
export * from "./userInfoRe.vue?vue&type=script&lang=js&"
import style0 from "./userInfoRe.vue?vue&type=style&index=0&id=39d632b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d632b8",
  null
  
)

export default component.exports